import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PasswordMatchValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const password = control.get('password')?.value;
  const passwordConfirm = control.get('passwordConfirm')?.value;

  // Check if both fields are identical and return an error if they are not
  return password === passwordConfirm ? null : { passwordsNotMatch: true };
};
